//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from '@/components/avatar';
import { mapState, mapMutations } from "vuex";
export default {
  name: 'RoomItem',
  components: { 'c-avatar': Avatar },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    server_time: {
      type: Date
    }
  },
  data() {
    return {
      curCaseInfo: null,
      curRoundIndex: 0,
      room: {},
      curInterval: null,
      countDown: 0,
      timeDifference: 0
    };
  },
  computed: {
    ...mapState(["user"]),
    joinCount() {
      return this.room.seatCount || 0;
    },
    joinUserList() {
      return this.room.players || [];
    },
    curCases() {
      if (!this.room.cases) {
        return [];
      }
      return this.room.cases.map(item => item);
    },
    curUserRealId() {
      return parseInt(this.user.id);
    },
    // 安全兼容映射：识别后端可能传过来的多种疯狂赛字段写法
    isCrazyMode() {
      return this.room.isCrazyMode !== undefined ? this.room.isCrazyMode : (this.room.is_crazy || 0);
    },
    // 安全兼容映射：识别后端可能传过来的多种团队赛字段写法
    isTeamMode() {
      return this.room.isTeamMode !== undefined ? this.room.isTeamMode : (this.room.is_team || 0);
    }
  },
  mounted() {
    this.room = { ...this.item };
    this.timeDifference = this.server_time.getTime() - Date.now();

    if (this.room.roomState == 1) {
      this.setRoomState();
      this.curInterval = setInterval(this.setRoomState, 500);
    }
  },
  beforeDestroy() {
    this.curInterval && clearInterval(this.curInterval);
  },
  watch: {
    item: {
      async handler(val, oldVal) {
        this.room = { ...val };
      },
      deep: true
    }
  },
  methods: {
    setRoomState() {
      var totalRoundTime = this.room.cases.length * 4000;
      var endtime = new Date(this.room.updatedTime.replace(/\-/g, "/")).getTime() - this.timeDifference + totalRoundTime;

      if (this.room.roomState == 1) {
        //this.room.roomState = 2;
        clearInterval(this.curInterval);
        this.$emit("on_room_end");
      } else {
        var ms_over = new Date().getTime() - new Date(this.room.updatedTime.replace(/\-/g, "/")).getTime() + this.timeDifference;
        this.curRoundIndex = Math.round(ms_over / totalRoundTime * this.room.cases.length) - 1; //计算经过了多少回合
        if (this.curRoundIndex < 0)
          this.curRoundIndex = 0;
      }
    },
    handleShowRoomDetail(item) {
      const query = { id: item.id }
      this.$router.push({
        name: this.isHappyCoin ? 'happyCoinBattleDetail' : 'battleDetail',
        params: { id: item.id },
        query: this.$route.query || {}
      })
    },
    handleJoinPk(item, btnType , seatIndex ) {
      if (item.roomState != 0)
        return this.handleShowRoomDetail(item);

      this.$emit("handleJoinPk", { ...item, btnType , seatIndex});
    },
    async openCaseDetail(item) {
      this.$emit("handleCase", item);
    }
  }
}
